// import React, { useState, useEffect, useRef } from "react";
// import { X, ChevronDown } from "lucide-react";
// import Cookies from "js-cookie";
// import api from "../../chat/api";
// import { toast } from "react-toastify";

// const ShareProjectModal = ({ isOpen, onClose, projectId, projectName, orgId, onShareSuccess }) => {
//   const [emailInput, setEmailInput] = useState("");
//   const [sharedPeople, setSharedPeople] = useState([]);
//   const [isSending, setIsSending] = useState(false);
//   const [shareSuccess, setShareSuccess] = useState(false);
//   const [showRoleDropdown, setShowRoleDropdown] = useState(false);
//   const [selectedRole, setSelectedRole] = useState("editor");
//   const [orgMembers, setOrgMembers] = useState([]);
//   const [showEmailDropdown, setShowEmailDropdown] = useState(false);
//   const [filteredMembers, setFilteredMembers] = useState([]);
//   const dropdownRef = useRef(null);
//   const emailDropdownRef = useRef(null);

//   // Fetch organization members when modal opens
//   useEffect(() => {
//     if (isOpen && orgId) {
//       const timer = setTimeout(() => {
//         fetchOrgMembers();
//       }, 1000);

//       return () => clearTimeout(timer);
//     }
//   }, [isOpen, orgId]);

//   // Fetch organization members
//   const fetchOrgMembers = async () => {
//     try {
//       const token = Cookies.get("access_token");
//       if (!token) {
//         console.error("No token available");
//         return;
//       }

//       if (!orgId) {
//         console.error("No organization ID available");
//         return;
//       }

//       // Updated API call to use organization_id query parameter
//       const response = await api.get(`/api/v1/org/members/list/?organization_id=${orgId}`);

//       if (response.data && Array.isArray(response.data)) {
//         setOrgMembers(response.data);
//       }
//     } catch (error) {
//       console.error("Error fetching organization members:", error);
//     }
//   };

//   // Reset form fields when modal closes
//   useEffect(() => {
//     if (!isOpen) {
//       setEmailInput("");
//       setSharedPeople([]);
//       setIsSending(false);
//       setShareSuccess(false);
//       setShowRoleDropdown(false);
//       setSelectedRole("editor");
//       setOrgMembers([]);
//       setShowEmailDropdown(false);
//       setFilteredMembers([]);
//     }
//   }, [isOpen]);

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setShowRoleDropdown(false);
//       }
//       if (emailDropdownRef.current && !emailDropdownRef.current.contains(event.target)) {
//         setShowEmailDropdown(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   // Email validation regex
//   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

//   // Handle email input change and filter members
//   const handleEmailInputChange = (e) => {
//     const value = e.target.value;
//     setEmailInput(value);

//     if (value.trim().length > 0) {
//       const filtered = orgMembers.filter(member => 
//         member.email.toLowerCase().includes(value.toLowerCase())
//       );
//       setFilteredMembers(filtered);
//       setShowEmailDropdown(true);
//     } else {
//       setShowEmailDropdown(false);
//       setFilteredMembers([]);
//     }
//   };

//   // Handle member selection from dropdown
//   const handleMemberSelect = (member) => {
//     setEmailInput(member.email);
//     setShowEmailDropdown(false);
//   };

//   // Handle role selection
//   const handleRoleSelect = (role) => {
//     setSelectedRole(role);
//     setShowRoleDropdown(false);
//   };

//   // Handle Enter key press
//   const handleKeyDown = (e) => {
//     if (e.key === "Enter" && emailInput.trim()) {
//       e.preventDefault();
//       const email = emailInput.trim();

//       // Validate email format
//       if (emailRegex.test(email)) {
//         // Check if email is not already in the list
//         if (!sharedPeople.find(person => person.email === email)) {
//           setSharedPeople([...sharedPeople, { email, role: selectedRole }]);
//         }
//         // Clear the input field and reset role
//         setEmailInput("");
//         setSelectedRole("editor");
//         setShowRoleDropdown(false);
//         setShowEmailDropdown(false);
//       } else {
//         toast.error("Please enter a valid email address");
//       }
//     }
//   };

//   // Remove person from shared list
//   const removePerson = (emailToRemove) => {
//     setSharedPeople(sharedPeople.filter((person) => person.email !== emailToRemove));
//   };

//   const handleShareProject = async () => {
//     if (sharedPeople.length === 0) {
//       toast.error("Please add at least one email address");
//       return;
//     }
  
//     if (!projectId) {
//       toast.error("Project ID not found");
//       return;
//     }
  
//     const token = Cookies.get("access_token");
//     if (!token) {
//       toast.error("No authentication token available");
//       return;
//     }
  
//     setIsSending(true);
//     setShareSuccess(false);
  
//     try {
//       // Map emails to user_ids, organization_ids, and permissions
//       const userIds = [];
//       const organizationIds = [];
//       const permissions = [];
  
//       for (const person of sharedPeople) {
//         const member = orgMembers.find(m => m.email === person.email);
//         if (member) {
//           userIds.push(member.user_id);
//           organizationIds.push(member.organization_id);
//           permissions.push(person.role);
//         }
//       }
  
//       const requestBody = {
//         organization_id: organizationIds,
//         user_ids: userIds,
//         message: `Collaborating on ${projectName}`,
//         permission: permissions
//       };
  
//       const response = await api.post(
//         `/api/v1/org/folders/${projectId}/share/`,
//         requestBody,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );
  
//       if (response.status === 200 || response.status === 201) {
//         const { shared = [], failed = [], message } = response.data;
  
//         setIsSending(false);
  
//         // Handle failed shares
//         if (failed.length > 0) {
//           failed.forEach(failure => {
//             toast.error(`${failure.email}: ${failure.reason}`);
//           });
//         }
  
//         // Handle successful shares
//         if (shared.length > 0) {
//           setShareSuccess(true);
//           toast.success(`Project shared successfully with ${shared.length} teammate(s)!`);
//         } else if (failed.length > 0 && shared.length === 0) {
//           // All shares failed
//           toast.warning(message || "Failed to share project with any teammates");
//         }
  
//         // Wait 1500ms before closing (only if some shares succeeded)
//         setTimeout(() => {
//           setEmailInput("");
//           setSharedPeople([]);
//           setShareSuccess(false);
//           onClose();
  
//           // Trigger parent component refresh if any shares succeeded
//           if (shared.length > 0 && onShareSuccess) {
//             onShareSuccess();
//           }
//         }, shared.length > 0 ? 1500 : 1000);
//       }
//     } catch (error) {
//       console.error("Error sharing project:", error);
//       setIsSending(false);
//       setShareSuccess(false);
  
//       if (error.response) {
//         const { data, status } = error.response;
  
//         // Check if response has the failed array structure
//         if (data.failed && Array.isArray(data.failed) && data.failed.length > 0) {
//           data.failed.forEach(failure => {
//             toast.error(`${failure.email}: ${failure.reason}`);
//           });
          
//           if (data.message) {
//             toast.info(data.message);
//           }
//         } else if (data.message) {
//           toast.error(data.message);
//         } else if (status === 400) {
//           toast.error("Bad request. Please check the email addresses.");
//         } else if (status === 401) {
//           toast.error("Session expired. Please login again.");
//         } else if (status === 403) {
//           toast.error("You don't have permission to share this project.");
//         } else if (status === 404) {
//           toast.error("Project not found.");
//         } else if (status === 500) {
//           toast.error("Server error. Please try again later.");
//         } else {
//           toast.error("An error occurred while sharing the project.");
//         }
//       } else if (error.request) {
//         toast.error("Network error. Please check your connection.");
//       } else {
//         toast.error("Failed to share project.");
//       }
  
//       // Close popup after 1 second when API call fails
//       setTimeout(() => {
//         onClose();
//       }, 1000);
//     }
//   };
  

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm font-outfit">
//       {/* Modal Container */}
//       <div className="bg-white rounded-xl shadow-xl w-full max-w-xl overflow-hidden animate-in fade-in zoom-in-95 duration-200">

//         {/* Header */}
//         <div className="p-6 pb-0">
//           <div className="flex justify-between items-start">
//             <div>
//               <h2 className="text-xl font-semibold text-[#18101C]">Share Project</h2>
//               <p className="text-[#52525B] text-sm mt-1">
//                 Share "{projectName}" with team members via email to start collaborating.
//               </p>
//             </div>
//             <button 
//               onClick={onClose}
//               disabled={isSending || shareSuccess}
//               className="text-gray-400 hover:text-gray-600 p-1 rounded-full hover:bg-gray-100 transition-colors -mt-1 -mr-1 disabled:opacity-50 disabled:cursor-not-allowed"
//             >
//               <X size={20} />
//             </button>
//           </div>
//         </div>

//         {/* Main Content Area with Border */}
//         <div className="m-6 p-6 border border-gray-200 rounded-2xl space-y-6">

//           {/* Email Input with Role Dropdown */}
//           <div className="space-y-2">
//             <label className="text-[15px] font-semibold !text-[#3F3F46]">
//               Email Address
//             </label>
//             <div className="relative" ref={emailDropdownRef}>
//               <div className="relative flex items-center">
//                 <input
//                   type="text"
//                   value={emailInput}
//                   onChange={handleEmailInputChange}
//                   onKeyDown={handleKeyDown}
//                   placeholder="Add email to share"
//                   disabled={isSending || shareSuccess}
//                   className="w-full px-4 pr-32 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#C95EBE]/20 focus:border-[#C95EBE] transition-colors box-border disabled:bg-gray-50 disabled:cursor-not-allowed"
//                   style={{ height: '46px', fontSize: '14px', lineHeight: '20px' }}
//                 />
//                 {emailInput.trim().length > 0 && (
//                   <button
//                     type="button"
//                     onClick={() => setShowRoleDropdown(!showRoleDropdown)}
//                     disabled={isSending || shareSuccess}
//                     className="absolute right-2 flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-md hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
//                   >
//                     {selectedRole.charAt(0).toUpperCase() + selectedRole.slice(1)}
//                     <ChevronDown size={16} className={`transition-transform ${showRoleDropdown ? 'rotate-180' : ''}`} />
//                   </button>
//                 )}
//               </div>

//               {/* Email Suggestions Dropdown */}
//               {showEmailDropdown && emailInput.trim().length > 0 && (
//                <div className="absolute left-0 mt-1 min-w-[300px] bg-white border border-gray-200 rounded-lg shadow-lg z-20 max-h-48 overflow-y-auto">   {filteredMembers.length > 0 ? (
//                     filteredMembers.map((member, index) => (
//                       <div
//                         key={index}
//                         onClick={() => handleMemberSelect(member)}
//                         className="flex items-center gap-3 px-3 py-2 hover:bg-gray-50 cursor-pointer transition-colors border-b border-gray-100 last:border-b-0"
//                       >
//                         <div className="w-10 h-10 rounded-full bg-[#C95EBE] flex items-center justify-center !text-white font-semibold text-sm flex-shrink-0">
//                           {member.full_name ? member.full_name.substring(0, 2).toUpperCase() : member.email.substring(0, 2).toUpperCase()}
//                         </div>
//                         <div className="flex-1 min-w-0">
//                           <p className="text-[14px] font-medium !text-[#18101C] truncate">
//                             {member.full_name || "User"}
//                           </p>
//                           <p className="text-xs text-[#3F3F46] truncate">
//                             {member.email}
//                           </p>
//                         </div>
//                       </div>
//                     ))
//                   ) : (
//                     <div className="px-4 py-3 text-sm text-[#3F3F46] text-center">
//                       No matching user found in organisation
//                     </div>
//                   )}
//                 </div>
//               )}

//               {/* Role Dropdown */}
//               {showRoleDropdown && emailInput.trim().length > 0 && (
//                 <div className="absolute right-0 mt-1 w-32 bg-white border border-gray-200 rounded-lg shadow-lg z-10 overflow-hidden" ref={dropdownRef}>
//                   <button
//                     type="button"
//                     onClick={() => handleRoleSelect("editor")}
//                     className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 transition-colors"
//                   >
//                     Editor
//                   </button>
//                   <button
//                     type="button"
//                     onClick={() => handleRoleSelect("reviewer")}
//                     className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 transition-colors"
//                   >
//                     Reviewer
//                   </button>
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* People Shared List - Fixed Height with Scroll */}
//           <div className="space-y-2">
//             <label className="text-[15px] font-semibold !text-[#3F3F46] flex justify-between">
//               <span>People Shared ({sharedPeople.length})</span>
//             </label>
//             <div className="w-full h-[120px] px-4 py-3 border border-gray-200 rounded-lg bg-white text-sm overflow-y-auto">
//               {sharedPeople.length === 0 ? (
//                 <span className="text-gray-400">No one added currently</span>
//               ) : (
//                 <div className="flex flex-wrap gap-2">
//                   {sharedPeople.map((person, index) => (
//                     <span 
//                       key={index} 
//                       className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-xl bg-[#BB42AE4D] text-[#18101C] border border-[#C95EBE]/20 h-fit"
//                     >
//                       {person.email}
//                       <span className="text-xs font-medium text-[#C95EBE]">
//                         ({person.role})
//                       </span>
//                       <button
//                         onClick={() => removePerson(person.email)}
//                         disabled={isSending || shareSuccess}
//                         className="hover:bg-[#C95EBE]/20 rounded-full p-0.5 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
//                       >
//                         <X size={14} />
//                       </button>
//                     </span>
//                   ))}
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* Share Button */}
//           <div className="flex justify-end">
//             <button
//               onClick={handleShareProject}
//               disabled={sharedPeople.length === 0 || isSending || shareSuccess}
//               className={`px-6 rounded-lg !text-white font-medium text-sm whitespace-nowrap transition-all box-border ${
//                 sharedPeople.length > 0 && !isSending && !shareSuccess
//                   ? "bg-[#C95EBE] hover:bg-[#b04da6] shadow-sm hover:shadow" 
//                   : "bg-[#C95EBE]/50 cursor-not-allowed"
//               }`}
//               style={{ height: '42px' }}
//             >
//               {shareSuccess ? "Shared" : isSending ? "Sharing..." : "Share Project"}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ShareProjectModal;
import React, { useState, useEffect, useRef } from "react";
import { X, ChevronDown, Search, Loader2 } from "lucide-react";
import Cookies from "js-cookie";
import api from "../../chat/api";
import hotToast from "react-hot-toast";

const ShareProjectModal = ({ isOpen, onClose, projectId, projectName, orgId, onShareSuccess }) => {
  const [sharedPeople, setSharedPeople] = useState([]);
  const [isSending, setIsSending] = useState(false);
  const [shareSuccess, setShareSuccess] = useState(false);
  const [orgMembers, setOrgMembers] = useState([]);
  const [loadingMembers, setLoadingMembers] = useState(false);
  const [memberSearch, setMemberSearch] = useState("");
  const [showMemberDropdown, setShowMemberDropdown] = useState(false);
  const memberDropdownRef = useRef(null);

  // Fetch organization members when modal opens
  useEffect(() => {
    if (isOpen && orgId) {
      const timer = setTimeout(() => {
        fetchOrgMembers();
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [isOpen, orgId]);

  // Fetch organization members
  const fetchOrgMembers = async () => {
    try {
      const token = Cookies.get("access_token");
      if (!token) {
        console.error("No token available");
        return;
      }

      if (!orgId) {
        console.error("No organization ID available");
        return;
      }

      setLoadingMembers(true);

      // Updated API call to use organization_id query parameter
      const response = await api.get(`/api/v1/org/members/list/?organization_id=${orgId}`);

      if (response.data && Array.isArray(response.data)) {
        setOrgMembers(response.data);
      }
    } catch (error) {
      console.error("Error fetching organization members:", error);
    } finally {
      setLoadingMembers(false);
    }
  };

  // Reset form fields when modal closes
  useEffect(() => {
    if (!isOpen) {
      setSharedPeople([]);
      setIsSending(false);
      setShareSuccess(false);
      setOrgMembers([]);
      setLoadingMembers(false);
      setMemberSearch("");
      setShowMemberDropdown(false);
    }
  }, [isOpen]);

  // Reset the search field whenever the dropdown closes
  useEffect(() => {
    if (!showMemberDropdown) {
      setMemberSearch("");
    }
  }, [showMemberDropdown]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (memberDropdownRef.current && !memberDropdownRef.current.contains(event.target)) {
        setShowMemberDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Org roles (Owner/Admin/Member) all share as "editor"; only reviewer stays read-only.
  const normalizePermission = (role) =>
    (role || "").toLowerCase() === "reviewer" ? "reviewer" : "editor";

  // Informational tag shown next to a member in the dropdown — reflects who they
  // are (workspace Owner / Admin), falling back to the permission they'd get.
  const roleTag = (member) => {
    if (member?.is_owner) return "Owner";
    if ((member?.role || "").toLowerCase() === "admin") return "Admin";
    return normalizePermission(member?.permission_role);
  };

  // Handle member selection from dropdown
  const handleMemberSelect = (member) => {
    if (!sharedPeople.find(person => person.email === member.email)) {
      setSharedPeople([
        ...sharedPeople,
        { email: member.email, role: normalizePermission(member.permission_role) || "" },
      ]);
    }
    setShowMemberDropdown(false);
  };

  // Remove person from shared list
  const removePerson = (emailToRemove) => {
    setSharedPeople(sharedPeople.filter((person) => person.email !== emailToRemove));
  };

  const handleShareProject = async () => {
    if (sharedPeople.length === 0) {
      hotToast.error("Please add at least one email address");
      return;
    }

    if (!projectId) {
      hotToast.error("Project ID not found");
      return;
    }

    const token = Cookies.get("access_token");
    if (!token) {
      hotToast.error("No authentication token available");
      return;
    }
  
    setIsSending(true);
    setShareSuccess(false);
  
    try {
      // Map emails to user_ids, organization_ids, and permissions
      const userIds = [];
      const organizationIds = [];
      const permissions = [];
  
      for (const person of sharedPeople) {
        const member = orgMembers.find(m => m.email === person.email);
        if (member) {
          userIds.push(member.user_id);
          organizationIds.push(member.organization_id);
          permissions.push((person.role || "").toLowerCase());
        }
      }
  
      const requestBody = {
        organization_id: organizationIds,
        user_ids: userIds,
        message: `Collaborating on ${projectName}`,
        permission: permissions
      };
  
      const response = await api.post(
        `/api/v1/org/folders/${projectId}/share/`,
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
  
      if (response.status === 200 || response.status === 201) {
        const { shared = [], failed = [], message } = response.data;
  
        setIsSending(false);
  
        // Handle failed shares
        if (failed.length > 0) {
          failed.forEach(failure => {
            hotToast.error(`${failure.email}: ${failure.reason}`);
          });
        }

        // Handle successful shares
        if (shared.length > 0) {
          setShareSuccess(true);
          hotToast.success(`Project shared successfully with ${shared.length} teammate(s)!`);
        } else if (failed.length > 0 && shared.length === 0) {
          // All shares failed
          hotToast.error(message || "Failed to share project with any teammates");
        }
  
        // Wait 1500ms before closing (only if some shares succeeded)
        setTimeout(() => {
          setSharedPeople([]);
          setShareSuccess(false);
          onClose();
  
          // Trigger parent component refresh if any shares succeeded
          if (shared.length > 0 && onShareSuccess) {
            onShareSuccess();
          }
        }, shared.length > 0 ? 1500 : 1000);
      }
    } catch (error) {
      console.error("Error sharing project:", error);
      setIsSending(false);
      setShareSuccess(false);
  
      if (error.response) {
        const { data, status } = error.response;
  
        // Check if response has the failed array structure
        if (data.failed && Array.isArray(data.failed) && data.failed.length > 0) {
          data.failed.forEach(failure => {
            hotToast.error(`${failure.email}: ${failure.reason}`);
          });

          if (data.message) {
            hotToast(data.message);
          }
        } else if (data.message) {
          hotToast.error(data.message);
        } else if (status === 400) {
          hotToast.error("Bad request. Please check the email addresses.");
        } else if (status === 401) {
          hotToast.error("Session expired. Please login again.");
        } else if (status === 403) {
          hotToast.error("You don't have permission to share this project.");
        } else if (status === 404) {
          hotToast.error("Project not found.");
        } else if (status === 500) {
          hotToast.error("Server error. Please try again later.");
        } else {
          hotToast.error("An error occurred while sharing the project.");
        }
      } else if (error.request) {
        hotToast.error("Network error. Please check your connection.");
      } else {
        hotToast.error("Failed to share project.");
      }
  
      // Close popup after 1 second when API call fails
      setTimeout(() => {
        onClose();
      }, 1000);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm font-outfit">
      {/* Modal Container */}
      <div className="bg-white rounded-xl shadow-xl w-full max-w-xl overflow-hidden animate-in fade-in zoom-in-95 duration-200">

        {/* Header */}
        <div className="p-6 pb-0">
          <div className="flex justify-between items-start">
            <div>
              <h2 className="text-xl font-semibold text-[#18101C]">Share Project</h2>
              <p className="text-[#52525B] text-sm mt-1">
                Share "{projectName}" with team members via email to start collaborating.
              </p>
            </div>
            <button 
              onClick={onClose}
              disabled={isSending || shareSuccess}
              className="text-gray-400 hover:text-gray-600 p-1 rounded-full hover:bg-gray-100 transition-colors -mt-1 -mr-1 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <X size={20} />
            </button>
          </div>
        </div>

        {/* Main Content Area with Border */}
        <div className="m-6 p-6 border border-gray-200 rounded-2xl space-y-6">

          {/* Member Select Dropdown */}
          <div className="space-y-2">
            <label className="text-[15px] font-semibold !text-[#3F3F46]">
              Select Member
            </label>
            <div className="relative" ref={memberDropdownRef}>
              <button
                type="button"
                onClick={() => setShowMemberDropdown((prev) => !prev)}
                disabled={isSending || shareSuccess}
                className="w-full px-4 flex items-center justify-between border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#C95EBE]/20 focus:border-[#C95EBE] transition-colors box-border text-left disabled:bg-gray-50 disabled:cursor-not-allowed"
                style={{ height: '46px', fontSize: '14px', lineHeight: '20px' }}
              >
                <span className="text-gray-400">Select a member to share</span>
                <ChevronDown size={18} className={`text-gray-400 transition-transform ${showMemberDropdown ? "rotate-180" : ""}`} />
              </button>

              {/* Member Dropdown List */}
              {showMemberDropdown && (
                <div className="absolute left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-20 overflow-hidden">
                  {/* Fixed Search Field */}
                  <div className="p-2 border-b border-gray-100 bg-white">
                    <div className="relative flex items-center">
                      <Search size={16} className="absolute left-3 text-gray-400" />
                      <input
                        type="text"
                        value={memberSearch}
                        onChange={(e) => setMemberSearch(e.target.value)}
                        placeholder="Search members"
                        className="w-full pl-9 pr-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#C95EBE]/20 focus:border-[#C95EBE] transition-colors"
                        style={{ fontSize: '14px', lineHeight: '20px' }}
                      />
                    </div>
                  </div>

                  {/* Scrollable List */}
                  <div className="max-h-48 overflow-y-auto">
                    {loadingMembers ? (
                      <div className="flex items-center justify-center gap-2 px-4 py-4 text-sm text-[#3F3F46]">
                        <Loader2 size={16} className="animate-spin text-[#C95EBE]" />
                        Fetching members...
                      </div>
                    ) : (() => {
                      const myEmail = (localStorage.getItem("email") || "").toLowerCase();
                      const availableMembers = orgMembers
                        // You can't share a project with yourself.
                        .filter(m => (m.email || "").toLowerCase() !== myEmail)
                        .filter(m => !sharedPeople.find(p => p.email === m.email))
                        .filter(m => {
                          const q = memberSearch.trim().toLowerCase();
                          if (!q) return true;
                          return (
                            (m.full_name || "").toLowerCase().includes(q) ||
                            (m.email || "").toLowerCase().includes(q)
                          );
                        });

                      if (availableMembers.length === 0) {
                        return (
                          <div className="px-4 py-3 text-sm text-[#3F3F46] text-center">
                            {memberSearch.trim() ? "No matching members found" : "No members available to share with"}
                          </div>
                        );
                      }

                      return availableMembers.map((member, index) => (
                        <div
                          key={index}
                          onClick={() => handleMemberSelect(member)}
                          className="flex items-center gap-3 px-3 py-2 hover:bg-gray-50 cursor-pointer transition-colors border-b border-gray-100 last:border-b-0"
                        >
                          <div className="w-10 h-10 rounded-full bg-[#C95EBE] flex items-center justify-center !text-white font-semibold text-sm flex-shrink-0">
                            {member.full_name ? member.full_name.substring(0, 2).toUpperCase() : member.email.substring(0, 2).toUpperCase()}
                          </div>
                          <div className="flex-1 min-w-0">
                            <p className="text-[14px] font-medium !text-[#18101C] truncate">
                              {member.full_name || "User"}
                              {member.permission_role && (
                                <span className="ml-1 text-xs font-medium text-[#C95EBE]">
                                  ({roleTag(member)})
                                </span>
                              )}
                            </p>
                            <p className="text-xs text-[#3F3F46] truncate">
                              {member.email}
                            </p>
                          </div>
                        </div>
                      ));
                    })()}
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* People Shared List - Fixed Height with Scroll */}
          <div className="space-y-2">
            <label className="text-[15px] font-semibold !text-[#3F3F46] flex justify-between">
              <span>People Shared ({sharedPeople.length})</span>
            </label>
            <div className="w-full h-[120px] px-4 py-3 border border-gray-200 rounded-lg bg-white text-sm overflow-y-auto">
              {sharedPeople.length === 0 ? (
                <span className="text-gray-400">No one added currently</span>
              ) : (
                <div className="flex flex-wrap gap-2">
                  {sharedPeople.map((person, index) => (
                    <span 
                      key={index} 
                      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-xl bg-[#BB42AE4D] text-[#18101C] border border-[#C95EBE]/20 h-fit"
                    >
                      {person.email}
                      <span className="text-xs font-medium text-[#C95EBE]">
                        ({person.role})
                      </span>
                      <button
                        onClick={() => removePerson(person.email)}
                        disabled={isSending || shareSuccess}
                        className="hover:bg-[#C95EBE]/20 rounded-full p-0.5 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        <X size={14} />
                      </button>
                    </span>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Share Button */}
          <div className="flex justify-end">
            <button
              onClick={handleShareProject}
              disabled={sharedPeople.length === 0 || isSending || shareSuccess}
              className={`px-6 rounded-lg !text-white font-medium text-sm whitespace-nowrap transition-all box-border ${
                sharedPeople.length > 0 && !isSending && !shareSuccess
                  ? "bg-[#C95EBE] hover:bg-[#b04da6] shadow-sm hover:shadow" 
                  : "bg-[#C95EBE]/50 cursor-not-allowed"
              }`}
              style={{ height: '42px' }}
            >
              {shareSuccess ? "Shared" : isSending ? "Sharing..." : "Share Project"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareProjectModal;